import { Link } from 'react-router-dom';
import { useLanguage } from '../utils/i18n';
import Logo from '../components/Logo';
import LanguageToggle from '../components/LanguageToggle';

export default function RefundPolicy() {
    const { t } = useLanguage();

    return (
        <div style={{ minHeight: '100vh', background: 'var(--bg)', color: 'var(--text)' }}>
            {/* Navbar */}
            <nav className="navbar">
                <Link to="/" className="navbar-brand">
                    <Logo size={24} />
                    <span>Wafiyo</span>
                </Link>
                <LanguageToggle />
            </nav>

            <div className="container" style={{ maxWidth: 720, paddingTop: 48, paddingBottom: 80 }}>
                <div className="glass-card" style={{ padding: '40px 32px' }}>

                    <h1 style={{ fontSize: 28, fontWeight: 800, marginBottom: 8 }}>{t('refund_policy_title')}</h1>
                    <p style={{ color: 'var(--text-muted)', fontSize: 13, marginBottom: 32 }}>{t('legal_last_updated')}: 26/02/2026</p>

                    <div className="legal-content">
                        <section>
                            <h2>{t('rp_intro_title')}</h2>
                            <p>{t('rp_intro_text')}</p>
                        </section>

                        <section>
                            <h2>{t('rp_trial_title')}</h2>
                            <p>{t('rp_trial_text')}</p>
                        </section>

                        <section>
                            <h2>{t('rp_subscriptions_title')}</h2>
                            <p>{t('rp_subscriptions_text')}</p>
                        </section>

                        <section>
                            <h2>{t('rp_refund_window_title')}</h2>
                            <p>{t('rp_refund_window_text')}</p>
                        </section>

                        <section>
                            <h2>{t('rp_exceptions_title')}</h2>
                            <p>{t('rp_exceptions_text')}</p>
                        </section>

                        <section>
                            <h2>{t('rp_how_title')}</h2>
                            <p>{t('rp_how_text')}</p>
                        </section>

                        <section>
                            <h2>{t('rp_contact_title')}</h2>
                            <p>{t('rp_contact_text')}</p>
                        </section>
                    </div>

                    <div style={{ marginTop: 32, textAlign: 'center' }}>
                        <Link to="/" className="btn btn-outline btn-sm glass-btn">{t('back_to_home')}</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
